import React from 'react'
import { IPayoutFields } from 'src/types/generated/contentful'
import { BackLink, TextBlock, Type } from '@/components/common'
import Image from '@/components/contentful/Image'
import DetailsCard from './DetailsCard'
import { articleOverride, disclaimerOverride } from './textOverrides'

interface Props {
  payout: IPayoutFields
}

const PayoutPage: React.FC<Props> = ({ payout }) => {
  return (
    <main className="h-full bg-core-gray-100 px-4 pb-6 pt-8">
      <div className="mx-auto max-w-7xl">
        <nav className="mb-8 flex">
          <BackLink href="/" text="Home" />
          <Type as="span" variant="caption-md" className="text-core-gray-500">
            <span className="mx-2">/</span>
            {payout.title}
          </Type>
        </nav>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 xl:gap-16">
          <div className="lg:order-2 lg:col-span-2">
            {payout.articleImage && (
              <Image
                image={payout.articleImage}
                className="mb-6 rounded-xl lg:hidden"
                width={992}
              />
            )}
            {payout.logo && (
              <Image
                image={payout.logo}
                className="mb-6 hidden lg:block"
                width={220}
              />
            )}

            {payout.message && (
              <TextBlock
                document={payout.message}
                optionOverrides={articleOverride}
              />
            )}

            <DetailsCard payout={payout} />
          </div>

          <div className="lg:order-1 lg:col-span-3">
            {payout.articleImage && (
              <Image
                image={payout.articleImage}
                className="mb-6 hidden rounded-xl lg:block"
                width={750}
              />
            )}

            <TextBlock
              document={payout.article}
              optionOverrides={articleOverride}
            />

            {payout.articleReferences && (
              <TextBlock
                document={payout.articleReferences}
                optionOverrides={disclaimerOverride}
              />
            )}
          </div>
        </div>
      </div>
    </main>
  )
}

export default PayoutPage
